import { render, staticRenderFns } from "./finance-paytypes.vue?vue&type=template&id=70b635a9"
import script from "./finance-paytypes.vue?vue&type=script&lang=js"
export * from "./finance-paytypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports